"use strict";

import moment from "moment";

function aplicarMascaraEmDataIso(data, valorDataVazia) {
  if (data) {
    return moment(data).format("DD/MM/YYYY");
  }

  return valorDataVazia ? valorDataVazia : null;
}

function aplicarMascaraDataHoraEmDataIso(data, valorDataVazia) {
  if (data) {
    return moment(data).format("DD/MM/YYYY HH:mm:ss");
  }

  return valorDataVazia ? valorDataVazia : null;
}

function aplicarMascaraDataHoraSemSegundos(data, valorDataVazia) {
  if (data) {
    return moment(data).format("DD/MM/YYYY HH:mm");
  }
  return valorDataVazia ? valorDataVazia : null;
}

function formatarDataEHoraIso(data, horario) {
  return `${moment(data).format("YYYY-MM-DD")}T${horario || "00:00:00"}`;
}

function formatarDataAnoMesDia(data) {
  return `${moment(data).format("YYYY/MM/DD")}`;
}

function dataFinalMaiorOuIgualDataInicial(dataInicial, dataFinal) {
  return (
    !dataInicial ||
    dataInicial == "" ||
    !dataFinal ||
    dataFinal == "" ||
    new Date(dataInicial) <= new Date(dataFinal)
  );
}

function primeiroDiaMes(dataSelecionada) {
  return moment.utc(dataSelecionada).startOf("month").toDate();
}

function primeiroDiaMesAtual(dataSelecionada) {
  var d = new Date(dataSelecionada);
  d.setDate(1);
  return d;
}

function descartarHoras(data){
  const dataSemHoras = new Date(data);
  dataSemHoras.setHours(0,0,0);
  return dataSemHoras;
}

function ultimoDiaMes(dataSelecionada) {
  return moment.utc(dataSelecionada).endOf("month").toDate();
}

function primeiroDiaSemana(dataSelecionada) {
  return moment.utc(dataSelecionada).startOf("week").toDate();
}

function primeiroDiaSemanaAtual(dataSelecionada){
  var d = new Date(dataSelecionada);
  d.setTime(d.getTime() - d.getDay() * 24 * 60 * 60 * 1000);
  return d;
}

function datePickerParaData(stringData){
  if(stringData != undefined)
    return new Date(stringData
      .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1T00:00:00"))
}

function ultimoDiaSemana(dataSelecionada) {
  return moment.utc(dataSelecionada).endOf("week").toDate();
}

function ultimosTrintaDias(dataSelecionada) {
  return new Date(new Date(dataSelecionada).setDate(new Date(dataSelecionada).getDate() - 30))
}

function somarNoventaDias(data) {
  return new Date(new Date(data).setDate(new Date(data).getDate() + 90));
}

function diaAnterior(hoje) {
  return new Date(new Date(hoje).setDate(new Date(hoje).getDate() - 1));
}

export default {
  dataFinalMaiorOuIgualDataInicial,
  aplicarMascaraDataHoraEmDataIso,
  aplicarMascaraDataHoraSemSegundos,
  formatarDataEHoraIso,
  aplicarMascaraEmDataIso,
  primeiroDiaMes,
  ultimoDiaMes,
  primeiroDiaSemanaAtual,
  primeiroDiaSemana,
  datePickerParaData,
  ultimoDiaSemana,
  primeiroDiaMesAtual,
  ultimosTrintaDias,
  descartarHoras,
  somarNoventaDias,
  formatarDataAnoMesDia,
  diaAnterior
};